import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import '../Styling/HomeNew.css';
import { heroImages, serviceImages, techIcons, aboutImages } from '../constants/images';

export default function HomeNew() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const heroSlides = [
    {
      image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&q=80&w=1920',
      title: 'Success Your Business',
      subtitle: 'We merge imagination and technology to help thousands of brands grow in an age of digital transformation',
      date: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    },
    {
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1920',
      title: 'The Modern Way to Make Successful',
      subtitle: 'We design brand, digital experience that engage the right customers',
      date: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    },
    {
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&q=80&w=1920',
      title: 'Business Planning Excellence',
      subtitle: 'Strategic planning and execution to achieve your business goals',
      date: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    },
    {
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80&w=1920',
      title: 'Market Research & Analysis',
      subtitle: 'Data-driven insights to make informed business decisions',
      date: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    },
    {
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=1920',
      title: 'Financial Consulting',
      subtitle: 'Expert financial guidance for sustainable growth',
      date: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    }
  ];

  useEffect(() => {
    document.title = 'QuantifyLogic - IT Solutions & Services';
    window.scrollTo(0, 0);
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <div className="homepage-wrapper">
      <section className="homepage-hero">
          <div className="hero-carousel">
            {heroSlides.map((slide, index) => (
              <div 
                key={index}
                className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
                style={{
                  backgroundImage: `url(${slide.image})`
                }}
              >
                <div className="hero-overlay"></div>
                <div className="slide-date">{slide.date}</div>
                <div className="hero-content">
                  <motion.h1 
                    className="homepage-title"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                  >
                    {slide.title}
                  </motion.h1>
                  <motion.p 
                    className="homepage-subtitle"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    {slide.subtitle}
                  </motion.p>
                  <motion.div 
                    className="homepage-action"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                  >
                    <Link to="/contactus" className="homepage-button">
                      Get A Quote
                      <span className="button-arrow">→</span>
                    </Link>
                  </motion.div>
                </div>
              </div>
            ))}
            <div className="carousel-indicators">
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
        </div>
      </section>   

      <section className="homepage-core">
          <div className="homepage-core-header">
            <motion.h2 
              className="homepage-core-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Our Core Services
            </motion.h2>
            <motion.p 
              className="homepage-core-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Comprehensive IT solutions tailored to elevate your business
            </motion.p>
          </div>
        <div className="homepage-core-grid">
          {[
              { 
                title: 'Application Development', 
                desc: 'Custom web and mobile solutions using cutting-edge technologies.',
                icon: '💻',
                image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=1000',
                link: '/services/application-development'
              },
              { 
                title: 'Software Testing', 
                desc: 'Comprehensive testing services ensuring quality and reliability.',
                icon: '🔍',
                image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&q=80&w=1000',
                link: '/services/software-testing'
              },
              { 
                title: 'IT Consulting', 
                desc: 'Strategic technology consulting for digital transformation.',
                icon: '🎯',
                image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=1000',
                link: '/services/it-consulting'
              },
              { 
                title: 'ERP Implementation', 
                desc: 'End-to-end ERP solutions for streamlined operations.',
                icon: '🔄',
                image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&q=80&w=1000',
                link: '/services/erp-implementation'
              },
              { 
                title: 'Digital Marketing', 
                desc: 'Comprehensive digital marketing services for growth.',
                icon: '📈',
                image: 'https://images.unsplash.com/photo-1533750516457-a7f992034fec?auto=format&fit=crop&q=80&w=1000',
                link: '/services/digital-marketing'
              },
              { 
                title: 'IT Training', 
                desc: 'Comprehensive IT training services for growth.',
                icon: '🎯',
                image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800',
                link: '/services/it-training'
              }
          ].map((item, idx) => (
            <motion.div
              key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                whileHover={{ y: -5 }}
              className="homepage-core-card"
            >
                <div className="card-image-container">
                  <img src={item.image} alt={item.title} className="card-image" />
                  <div className="card-overlay"></div>
                  <span className="card-icon">{item.icon}</span>
                </div>
                <div className="homepage-core-card-content">
                  <div className="homepage-core-card-text">
              <h3 className="homepage-core-card-title">{item.title}</h3>
              <p className="homepage-core-card-desc">{item.desc}</p>
                  </div>
                  <div className="homepage-core-card-footer">
                    <Link to={item.link} className="homepage-core-card-link">
                      Learn More
                      <span className="link-arrow">→</span>
                    </Link>
                  </div>
                </div>
            </motion.div>
          ))}
        </div>
      </section>

        {/* About Section */}
        <section className="homepage-about">
          <div className="section-container">
            <motion.div
              className="about-content"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="about-left">
                <div className="about-image">
                  <img src={aboutImages.mission} alt="Our Mission - Corporate Excellence" />
                </div>
                <div className="about-stats">
                  {[
                    { number: '200+', text: 'Projects Delivered', icon: '🎯' },
                    { number: '50+', text: 'Expert Professionals', icon: '👥' },
                    { number: '95%', text: 'Client Satisfaction', icon: '⭐' }
                  ].map((stat, index) => (
                    <motion.div
                      key={index}
                      className="stat-card"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1, duration: 0.5 }}
                    >
                      <span className="stat-icon">{stat.icon}</span>
                      <h3>{stat.number}</h3>
                      <p>{stat.text}</p>
                    </motion.div>
                  ))}
                </div>
              </div>
              <div className="about-right">
                <h2>About QuantifyLogic</h2>
                <p>
                  We are a team of passionate technologists dedicated to delivering innovative solutions 
                  that drive business success. Our mission is to empower businesses through cutting-edge 
                  technology solutions while maintaining the highest standards of quality and customer 
                  satisfaction.
                </p>
                <div className="about-values">
                  <h3>Our Core Values</h3>
                  <div className="values-grid">
                    {[
                      {
                        title: 'Innovation',
                        description: 'We constantly push boundaries to deliver cutting-edge solutions.',
                        icon: '💡'
                      },
                      {
                        title: 'Excellence',
                        description: 'Quality and perfection are at the heart of everything we do.',
                        icon: '⭐'
                      },
                      {
                        title: 'Integrity',
                        description: 'We maintain the highest standards of honesty and transparency.',
                        icon: '🤝'
                      }
                    ].map((value, index) => (
                      <motion.div
                        key={index}
                        className="value-card"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.1, duration: 0.5 }}
                      >
                        <span className="value-icon">{value.icon}</span>
                        <h4>{value.title}</h4>
                        <p>{value.description}</p>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="homepage-tech">
          <motion.h2 
            className="tech-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Technologies We Work With
          </motion.h2>
          <div className="tech-grid">
            {[
              {
                name: 'React',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
              },
              {
                name: 'Angular',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg'
              },
              {
                name: 'Node.js',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg'
              },
              {
                name: 'Python',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg'
              },
              {
                name: 'Java',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg'
              },
              {
                name: 'AWS',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg'
              },
              {
                name: 'Docker',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg'
              },
              {
                name: 'Kubernetes',
                icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg'
              }
            ].map((tech, idx) => (
              <motion.div
                key={tech.name}
                className="tech-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
              >
                <img src={tech.icon} alt={tech.name} className="tech-icon" />
                <span className="tech-name">{tech.name}</span>
              </motion.div>
            ))}
          </div>
        </section>

        <section className="homepage-cta" style={{
          backgroundImage: `url(${heroImages.overlay})`
        }}>
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
        <h2 className="homepage-cta-title">Ready to Transform Your Business?</h2>
            <p className="homepage-cta-subtitle" style={{color: 'black'}}>Let us help you streamline operations, scale faster, and achieve more.</p>
        <Link to="/contactus" className="homepage-contact-button">
              Get Started
              <span className="button-arrow">→</span>
        </Link>
          </motion.div>
      </section>

      
    </div>
      <Footer />
    </>
  );
}


